'use client';

import { useState, useEffect } from 'react';
import { getUserData } from '@/lib/auth';
import { CustomerModel, } from '../../models'
import MonthsPicker from './MonthsPicker';
import { Calendar, ClipboardX } from 'lucide-react';
import { numberFunc, } from '../../utils'
import Loading from '@/components/Loading';

const customer_model = new CustomerModel()

export default function PromotionPage() {
  interface Receipt {
    receipt_code: string;
    receipt_date: string;
    receipt_total_price: string;
    company_branch_name: string;
    receipt_document_status: string;
  }
  interface Month {
    start_date: String,
    end_date: String,
    month: String,
    year: Number,
  }
  const months = [
    'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
    'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
  ];
  const [isLoading, setIsLoading] = useState(true);
  const today = new Date();
  const start = new Date(today.getFullYear(), today.getMonth(), 1);
  const end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const today_start = `${start.getFullYear()}-${start.getMonth()}-${start.getDate()}`
  const today_end = `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`
  const today_month = months[today.getMonth()]

  const [receipts, setReceipts] = useState<any>([]);
  const [user, setUser] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState<Month>({
    start_date: today_start, end_date: today_end, month: today_month, year: today.getFullYear() 
  });

  useEffect(() => {
    (async () => {
      try {
        const userData = await getUserData();

        if (userData) {
          await setUser(userData);
          const receipts = await customer_model.getCustomerReceipt({ 
            customer_code: userData.customer_code,
            start_date: selectedMonth.start_date,
            end_date: selectedMonth.end_date,
          })
          setReceipts(receipts.data);
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    })()
  }, []);


  const handleMonthSelect = async (month: Month) => {
    handleCloseModal();
    setIsLoading(true);
    const receipts = await customer_model.getCustomerReceipt({ 
      customer_code: user.customer_code,
      start_date: month.start_date,
      end_date: month.end_date,
    })
    setReceipts(receipts.data);
    setSelectedMonth(month);
    setIsLoading(false);
  };

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <div className="p-4 min-h-screen ">
      {isLoading ? <Loading /> : <>
        <div className="grid gap-3 h-[100%]">
          {receipts.length ? receipts.map((receipt: Receipt) => (
            <div key={receipt.receipt_code} className="bg-white rounded-lg shadow-md overflow-hidden">
              <h4 className={`line-clamp-2 text-orange-500 p-2`}>
                <p className="float-left text-s"><b>{receipt.receipt_code}</b></p>
                <p className="float-right text-sm text-orange-400 pt-1">{receipt.receipt_date}</p>
              </h4>
              <div className="p-3">
                <div className="grid grid-cols-2 gap-3">
                  <p className="text-sm text-gray-600 line-clamp-2">{`สาขา : ${receipt.company_branch_name}`}</p>
                </div>
                <div className="mt-1">
                  <div className="grid grid-cols-2 gap-3">
                    <p className="text-sm text-gray-600 line-clamp-2">{`ราคา : ${numberFunc.decimalFix(receipt.receipt_total_price, 0)} บาท`}</p>
                  </div>
                </div>
              </div>
            </div>
          )) : 
            <div className="w-full flex-1 flex items-center justify-center text-gray-500 text-center flex-col min-h-[60vh]">
              <ClipboardX className="w-20 h-20"/>
              ไม่พบประวัติการซื้อ
            </div>
          }
        </div>
      </>}


      <div className="fixed max-w-md bottom-0 left-0 right-0 z-50 bg-orange-100 p-2 mx-auto border-t border-gray-200 shadow-xl">
        <div>
          <button className="w-[100%] mb-2 mt-2 p-2 bg-stone-500 hover:bg-stone-600 text-white rounded-lg gap-2"  onClick={handleOpenModal}>
            <Calendar className="inline w-5 h-5 mr-1 mb-1" />
            {`${selectedMonth.month} ${selectedMonth.year}`}
          </button>
        </div>
      </div>
      
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <MonthsPicker onMonthSelect={handleMonthSelect} />
            <button className="w-[90%] mb-3 p-2 bg-gray-400 hover:bg-gray-500 text-white rounded-xl" onClick={handleCloseModal}>ปิด</button>
          </div>
        </div>
      )}
    </div>
  );
}
